import { PUBLIC_MEDIA_URL } from '$env/static/public';

/**
   * простой хелпер чтобы не писать везде конкатенацию
   * @param relativeUrl
   */
export default function getMediaUrl(relativeUrl?: string, placeholder?: any) {
  if (!relativeUrl) return placeholder || relativeUrl;

  // console.log('media url', relativeUrl);

  if (relativeUrl.startsWith('http')) return relativeUrl;

  return PUBLIC_MEDIA_URL + relativeUrl;
}
